// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {NavigationGuardNext, Route} from 'vue-router';
import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

export enum Performance {
  PerformanceTab = 'PerformanceTab',
}

const performanceRoutes = [
  {
    path: '/clientdashboard/performance',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/layouts/authenticated/Index.vue'),
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    meta: {
      useLayouts: true,
    },
    children: [
      {
        path: '',
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/components/performance/PerformanceWrapper.vue'),
        name: Performance.PerformanceTab,
        meta: {
          useLayouts: true,
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
          await Promise.all([
            store.dispatch('accountList/loadAccountList'),
            store.dispatch('account/getLatestCustodianLoadData'),
          ]);

          next();
        },
      },
    ],
  },
];

export default performanceRoutes;
